






































import Vue from 'vue'
import { ContentPrice } from '@/components/common/Content.vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Vue2Filters from 'vue2-filters'
import { FramePuzzleModule, PuzzleBoxState, PuzzleFormat } from '../../../store/modules/framePuzzle'
import { AssetsModule } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { ErrorsModule } from '@/store/modules/error'
import i18n from '@/i18n'
import { Product } from "@/rest";

interface BoxTypePrice {
    [key: string]: number
}
interface MinPrices {
    [key: string]: BoxTypePrice
}

Vue.use(Vue2Filters)

@Component({
    name: 'frame-puzzle-headline'
})

export default class FramePuzzleHeadline extends ContentPrice {
    private fontSize = '20px'
    private showModal = false
    private tempParts = '0'
    private currentParts = FramePuzzleModule.parts
    private selected = FramePuzzleModule.parts
    private priceInitialised = false

    @Prop() private titleKey!: string
    get price() {
        if (AppModule.session.products !== undefined) {
            const prices: MinPrices = {}
            let price = 0;
            let parts = '';

            for (let i = 0; i < AppModule.session.products.length; i++) {
                const product: Product = AppModule.session.products[i];

                // create a mapping of parts -> box type -> price to search for the lowest price if no box is choosen
                if (product.parts !== undefined && product.boxType !== undefined && product.price !== undefined && product.price.price !== undefined) {
                    prices[product.parts] = prices[product.parts] || {};
                    prices[product.parts][product.boxType] = product.price.price;
                }

                if (product.itemId === AppModule.productID) {
                    parts = product.parts || '';
                    if (product.price !== undefined && product.price.price !== undefined) {
                        price = product.price.price
                    }
                }
            }
            if (FramePuzzleModule.boxState != PuzzleBoxState.NONE || prices[parts] === undefined) {
                return price;
            } else {
                // search for the cheapest
                return Math.min.apply(null, Object.values(prices[parts]))
            }
        }
        return ""
    }

    @Watch('parts')
    partsChanged(newParts: string) {
        this.currentParts = newParts
        this.selected = newParts
    }

    get partsOptions() {
        return FramePuzzleModule.availableParts
    }

    get showGiftOptions() {
        return AppModule.showGiftOptions
    }

    get parts() {
        return FramePuzzleModule.parts
    }
    
    get deliveryCountry() {
        if (AppModule.session.deliveryCountry) {
            return i18n.t(AppModule.session.deliveryCountry.toLowerCase())
        }
        return ""
    }

    showShippingCost() {
        AppModule.SetShowShippingOverlay(true)
    }

    setSelectedItem(selected: string) {
        this.tempParts = selected
        this.showModal = true
    }

    hideModal() {
        this.showModal = false
        this.selected = this.currentParts
    }

    toggleModal() {
        FramePuzzleModule.SetParts(this.tempParts)
        this.showModal = false
        this.currentParts = this.tempParts
        this.resetCustomPuzzle()
    }

    hasCardboard(newParts: string) {
        let boxes = FramePuzzleModule.availableBoxes
        for (let i = 0; i < boxes.length; i++) {
            if (boxes[i].parts === newParts) {
                return boxes[i].boxes[0]
            }
        }
        return false
    }

    hasMetal(newParts: string) {
        let boxes = FramePuzzleModule.availableBoxes
        for (let i = 0; i < boxes.length; i++) {
            if (boxes[i].parts === newParts) {
                return boxes[i].boxes[1]
            }
        }
        return false
    }

    deleteAllUsages() {
        Object.keys(FramePuzzleModule.activeAssets).forEach(key => {
            FramePuzzleModule.UnsetActiveAsset(key)
        })
        AssetsModule.ClearAssets(true)
        AssetsModule.ClearValidAssets(true)
        AssetsModule.ClearSelectedAssets(true)
        Object.keys(FramePuzzleModule.allCollages).forEach(key => {
            FramePuzzleModule.ClearAllCollages(key)
        })
        Object.keys(FramePuzzleModule.persistedAssets).forEach(key => {
            FramePuzzleModule.ClearPersistedAssetData(key)
        })
    }

    resetToolbarErrorKeys() {
        for (let i = 0; i < ToolbarModule.errorKeys.length; i++) {
            ToolbarModule.UnsetErrorKey(ToolbarModule.errorKeys[i])
        }
    }

    resetErrorModule() {
        Object.keys(ErrorsModule.keys).forEach(key => {
            ErrorsModule.SetError({ key: ErrorsModule.keys[Number(key)] })
        })
    }

    resetCustomPuzzle() {
        FramePuzzleModule.SetBoxDesign(1)
        FramePuzzleModule.SetPuzzleFormat(PuzzleFormat.LANDSCAPE)
        FramePuzzleModule.SetUserFormat("")
        FramePuzzleModule.SetBoxState(PuzzleBoxState.NONE)
        FramePuzzleModule.SetStepsReseted(!FramePuzzleModule.stepsReseted)
        this.deleteAllUsages()
        AppModule.ResetSteps(true)
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        ToolbarModule.SetToolbarError(false)
        this.resetToolbarErrorKeys()
        this.resetErrorModule()
        AppModule.SetActiveStep(0)
        AppModule.SetHidePreviewButton(true)
    }
}
